import Image from 'next/image'

import Link from '@/atoms/Link/Link'

interface Props {
  title: string
  description: string
  featuredImage: StrapiImageFile
  awardsList: StrapiImageFile[]
  primaryCta: StrapiLinkSharedComponent
  secondaryCta?: StrapiLinkSharedComponent
}

function CaseStudyHomePageHero({
  title,
  description,
  featuredImage,
  awardsList,
  primaryCta,
  secondaryCta
}: Props) {
  return (
    <section className="font-heading | bg-blue-web-90">
      <div className="container | grid grid-cols-1 lg:grid-cols-12 items-center gap-6 | py-14 md:py-18">
        <div className="lg:col-span-6 | mb-10 md:mb-0">
          <h1
            className="text-4xl md:text-5xl text-white font-semibold | mb-2 md:mb-5"
            dangerouslySetInnerHTML={{ __html: title }}
          />

          <p className="text-sm md:text-base text-gray-40 | mb-5">
            {description}
          </p>

          <div className="flex flex-wrap justify-center md:justify-start gap-6 | mb-9 md:mb-10">
            {awardsList.map(item => (
              <Image
                key={item.url}
                src={item.url}
                alt={item.alternativeText ?? ''}
                width={item.width}
                height={item.height}
                priority={true}
                className="w-14 md:w-24"
              />
            ))}
          </div>
          <div className="flex flex-col md:flex-row justify-center md:justify-start gap-6 | w-full">
            <Link
              href={primaryCta.href}
              target={primaryCta.target}
              className="font-body | flex-grow | text-center text-xl text-blue-web-50 bg-white font-medium | border border-blue-web-50 rounded-lg max-h-14 py-4 px-6"
            >
              {primaryCta.title}
            </Link>
            {secondaryCta ? (
              <Link
                href={secondaryCta.href}
                target={secondaryCta.target}
                className="font-body | flex-grow | text-center text-xl bg-blue-50 text-white font-medium | rounded-lg max-h-14 py-4 px-6"
              >
                {secondaryCta.title}
              </Link>
            ) : null}
          </div>
        </div>
        <div className="lg:col-span-6 | rounded-3xl">
          {featuredImage.url ? (
            <Image
              src={featuredImage.url ?? ''}
              alt={featuredImage.alternativeText ?? ''}
              width={featuredImage.width}
              height={featuredImage.height}
              priority={true}
            />
          ) : null}
        </div>
      </div>
    </section>
  )
}

export default CaseStudyHomePageHero
